<button [type]="type" [disabled]="disabled" [ngClass]="fullButtonClass" [ngStyle]="buttonStyle"
  (click)="onClick($event)" (keypress)="onClick($event)" [attr.aria-label]="text"
  [attr.aria-disabled]="disabled ? 'true' : 'false'" [attr.data-size]="size" [attr.data-color]="color" class="w-full">
  @if (icon && placeIcon === 'left') {
  <img src="icons/{{ icon }}.svg" height="24px" width="24px" alt="icono avion" />
  }
  {{ text }}
  @if (icon && placeIcon === 'right') {
  <img src="icons/{{ icon }}.svg" height="24px" width="24px" alt="icono avion" />
  }
</button>